import React from "react";
import PropTypes from "prop-types";
import {setupOnExtractData} from "../../../util/FormUtil";
import {PROP_NAME_EMAIL} from "./EmailInputComponent";
import UserDataService from "../../common/UserDataService";
import {fetchResponseHandler} from "../../../util/FetchUtil";

const CHANGE_INFO_TEXT = `You can change your User ID to be the same as your email
address or you can continue using your existing User ID.`;
const CHECKBOX_TEXT = `Change User ID to my email address
(this cannot be changed once it is saved)`;
const CANNOT_UPDATE_TEXT = `This User ID cannot be updated as the email is already in use.`;

const PROP_NAME_USER_ID = "userId";
const PROP_NAME_USER_NAME = "userName";
const PROP_NAME_UPDATE_USERNAME_SAME_AS_EMAIL = "updateUserNameSameAsEmail";

class UpdateUserNameAsEmailInputComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            serverSideCheckComplete: false,
            emailUserNameUsed: true     // lock the option until server-side responds
        }

        this.checkIsEmailUserNameUsed = this.checkIsEmailUserNameUsed.bind(this);
        this.extractData = this.extractData.bind(this);
        this.updateUserNameSameAsEmail = this.updateUserNameSameAsEmail.bind(this);
    }

    componentDidMount() {
        setupOnExtractData(this);
        this.checkIsEmailUserNameUsed();
    }

    checkIsEmailUserNameUsed() {
        const {data, userDataService} = this.props;
        const email = data[PROP_NAME_EMAIL] || '';
        const userId = data[PROP_NAME_USER_ID] || '';

        userDataService.isEmailUserNameUsed(JSON.stringify({email, userId}))
            .then(fetchResponseHandler)
            .then(resp => {
                this.setState({ emailUserNameUsed: resp.truth, serverSideCheckComplete: true });
            }).catch(e => {
                console.log(e);
                // assume worst-case if server-side check fails
                this.setState({ emailUserNameUsed: true });
            })
        ;
    }

    extractData() {
        let {data} = this.props;
        const result = data[PROP_NAME_UPDATE_USERNAME_SAME_AS_EMAIL];
        return result;
    };

    updateUserNameSameAsEmail(e) {
        const {setFormState} = this.props;
        setFormState({
            property: PROP_NAME_UPDATE_USERNAME_SAME_AS_EMAIL, data: e.target.checked,
            metadata: {dirty: true, valid: true}
        });
    }

    render() {
        const {data, oldEmailSameAsUserName} = this.props;
        const {emailUserNameUsed, serverSideCheckComplete} = this.state;
        const userName = data[PROP_NAME_USER_NAME] || "";
        const displayUpdateOption = !oldEmailSameAsUserName; // evaluated @ form

        return (
            <React.Fragment>
                {
                    displayUpdateOption &&
                    <div className={"grid form-fields"}>
                        <div className="grid__col-md-6 grid__col-sm-12">
                            <label htmlFor={PROP_NAME_USER_NAME}>User ID</label>
                            {CHANGE_INFO_TEXT}
                            <input id={PROP_NAME_USER_NAME}
                                   style={{maxHeight: '28px'}}
                                   className={"text-input text-input--large"}
                                   value={userName}
                                   disabled={"disabled"}
                            />
                            <div className={"display--flex push--top"}>
                                <input
                                    type={"checkbox"}
                                    name={PROP_NAME_UPDATE_USERNAME_SAME_AS_EMAIL}
                                    id={PROP_NAME_UPDATE_USERNAME_SAME_AS_EMAIL}
                                    checked={data[PROP_NAME_UPDATE_USERNAME_SAME_AS_EMAIL]}
                                    onChange={this.updateUserNameSameAsEmail}
                                    disabled={emailUserNameUsed ? "disabled" : null}
                                />
                                <label htmlFor={PROP_NAME_UPDATE_USERNAME_SAME_AS_EMAIL}
                                       style={{marginLeft: '5px', "text-transform": 'none'}}>
                                    {CHECKBOX_TEXT}
                                </label>
                                {
                                    serverSideCheckComplete && emailUserNameUsed &&
                                    <div className="error display--block">{CANNOT_UPDATE_TEXT}</div>
                                }
                            </div>
                        </div>
                    </div>
                }
            </React.Fragment>
        );
    }
}

UpdateUserNameAsEmailInputComponent.propTypes = {
    data: PropTypes.object.isRequired,
    onExtractData: PropTypes.func.isRequired,
    setFormState: PropTypes.func.isRequired,
    userDataService: PropTypes.instanceOf(UserDataService).isRequired
};

export default UpdateUserNameAsEmailInputComponent;